<template>
  <b-container id="prisesEnCharges">
    <b-tabs pills vertical data-toggle="collapse" v-model="tabIndex">
      <b-tab
        v-for="item in prisesEnCharges"
        :key="item.title"
        :title="item.subtitle"
        :id="item.logo"
      >
        <b-card-text>
          <p class="title d-none d-lg-block">
            <img class="logo" :src="logoSource(item.logo)" />
            {{ item.title }}
          </p>
          <component :id="item.title" :is="item.content" />
        </b-card-text>
      </b-tab>
    </b-tabs>
  </b-container>
</template>

<script>
import DepistageVisuel from "./PrisesEnCharges/DepistageVisuel";
import InsuffisanceConvergence from "./PrisesEnCharges/InsuffisanceConvergence";
import Strabisme from "./PrisesEnCharges/Strabisme";
import Vertiges from "./PrisesEnCharges/Vertiges";
import BasseVision from "./PrisesEnCharges/BasseVision";
import Apprentissage from "./PrisesEnCharges/Apprentissage";
import NeuroVisuelle from "./PrisesEnCharges/NeuroVisuelle";
import TeleMedecine from "./PrisesEnCharges/TeleMedecine";
import PrescriptionOptique from "./PrisesEnCharges/PrescriptionOptique";

export default {
  components: {
    DepistageVisuel,
  },
  data() {
    return {
      tabIndex: 0,
      tabs: [
        "#depistage",
        "#convergence",
        "#strabisme",
        "#vertiges",
        "#basse",
        "#apprentissage",
        "#neurovisuelle",
        "#tele",
        "#prescription",
      ],
      prisesEnCharges: [
        {
          title: "Dépistage visuel",
          subtitle: "Dépistage visuel",
          content: DepistageVisuel,
          logo: "optometry.svg",
          link: "depistage",
        },
        {
          subtitle: "Convergence et accommodation",
          title: "Insuffisance de convergence et d'accomodation",
          content: InsuffisanceConvergence,
          logo: "convergence.svg",
          link: "convergence",
        },
        {
          subtitle: "Strabisme et Amblyopie",
          title: "Strabisme et Amblyopie",
          content: Strabisme,
          logo: "cross-arrows.svg",
        },
        {
          subtitle: "Vertiges",
          title: "Vertiges et déséquilibre oculo-vestibulaire",
          content: Vertiges,
          logo: "dizzy.svg",
        },
        {
          subtitle: "Basse vision",
          title: "Basse vision",
          content: BasseVision,
          logo: "vision.svg",
        },
        {
          subtitle: "Difficultés d'apprentissage",
          title: "Difficultés d’apprentissages scolaires",
          content: Apprentissage,
          logo: "design.svg",
        },
        {
          subtitle: "Prise en charge neurovisuelle",
          title: "Prise en charge neurovisuelle",
          content: NeuroVisuelle,
          logo: "stroke.svg",
        },
        {
          subtitle: "Télémedecine",
          title: "Dépistage de la rétinopathie diabétique",
          content: TeleMedecine,
          logo: "medical-history.svg",
        },
        {
          subtitle: "Examen de vue",
          title: "Prescription ou renouvellement optique",
          content: PrescriptionOptique,
          logo: "foroptero.svg",
        },
      ],
    };
  },
  methods: {
    logoSource(logo) {
      return require("../assets/icons_keyword/" + logo);
    },
  },
  mounted() {
    console.log(this.$route.hash);
    this.tabIndex = this.tabs.findIndex((tab) => tab === this.$route.hash);
  },
};
</script>

<style lang="stylus">
@import '../css/palette.styl';

#prisesEnCharges {
  margin-top: 50px;
}

#prisesEnCharges img {
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

#prisesEnCharges .title {
  font-size: 1.5rem;
  margin-bottom: -10px;
}

#prisesEnCharges .logo {
  max-width: 50px;
  margin-right: 20px;
}
</style>
